// model
import Accomodation from "@/model/Accomodation"
import { ITraveller } from "@/model/Traveller"
import AccomodationContent, { IAccomodationContent } from '@/model/Content/AccomodationContent'
import BookingData from "@/classes/BookingData"

import { LiheContentResponseDTO, PrestationContent, PrestationQuote, QuoteState } from "@requests"

const processAccomodations = (bookingData: BookingData, sourceObj: QuoteState) => {
    // create accomodation objects and interconnect with travellers
    Object.values(sourceObj.prestations).forEach((prestationFamilyObj: PrestationQuote[]) => {
        prestationFamilyObj.forEach((prestationObj: PrestationQuote) => {
            // skip not selected accomodations, as it's not relevant for the Booking Funnel
            if (!prestationObj.travellers.find((traveller) => traveller.selected)) return

            const split = prestationObj.id.split("_")
            const accId = split[split.length - 1]
            const liheContentResponse = bookingData.responses.liheContentResponse as LiheContentResponseDTO
            const liheContent: PrestationContent | undefined = liheContentResponse.prestations.find((prestObj) => {
                return String(prestObj['id']) === String(accId)
            })
            if (!liheContent) throw new Error("liheContent cannot be undefined")
            const accName: string = liheContent.prestationName
            const description = "" // FIXME
            const accomodationContent: IAccomodationContent = new AccomodationContent(accName, description)

            // create accomodation
            const accomodation = new Accomodation(
                prestationObj.id,
                prestationObj.quantity,
                prestationObj.startDate,
                prestationObj.endDate,
            )

            // set quote traveller objects
            accomodation.setQuoteTravellers(prestationObj.travellers)

            // save source object
            accomodation.setBaseAccomodationQuoteObject(prestationObj)

            // set prices
            prestationObj.amount && accomodation.setCrossPrice(prestationObj.amount)

            // set content
            accomodation.setAccomodationContent(accomodationContent)
            accomodationContent.setAccomodation(accomodation)

            // save accomodation in booking data
            bookingData.accomodationsArr.push(accomodation)
            bookingData.accomodationsMap.set(accomodation.getIdFull(), accomodation)
            bookingData.lihe.addAccomodation(accomodation)

            // interconnect travellers and accomodations while still in the same loop, not to start another one
            prestationObj.travellers.forEach((travellerObj) => {
                if (!bookingData.travellersMap.get(travellerObj.id)) throw new Error(`traveller instance does not exist for this traveller id: ${travellerObj.id}`)
                const traveller: ITraveller = bookingData.travellersMap.get(travellerObj.id)!
                accomodation.addTraveller(traveller)
                traveller.addAccomodation(accomodation)
            })
        })
    })
}

export default processAccomodations